import Vue from 'vue';
import VueI18n from 'vue-i18n';
import dayjs from 'dayjs';

Vue.use(VueI18n);

function loadLocaleMessages() {
  const requireLang = require.context('@/locales', true, /\.json$/);
  const messages = {};
  for (const file of requireLang.keys()) {
    if (file === './index.js') continue;
    const path = file.replace(/(\.\/|\.json$)/g, '').split('/');
    path.reduce((o, s, i) => {
      if (o[s]) return o[s];
      o[s] = i + 1 === path.length ? requireLang(file) : {};
      return o[s];
    }, messages);
  }
  return messages;
}

const localeList = ['ko', 'en']
const defaultLocale = 'en';

function getLocale() {
  let locale = 'ko';
  let sLocale = localStorage.getItem('grm_locale');
  if(!sLocale){
    sLocale = navigator && navigator.language.substring(0, 2);
  }
  if(sLocale && localeList.includes(locale)){
    locale = sLocale;
  }
  return locale;
}

export default ({ app }) => {
  app.i18n = new VueI18n({
    locale: getLocale(),
    fallbackLocale: defaultLocale,
    messages: loadLocaleMessages(),
  });
  Object.assign(app.i18n, {
    setLocale: function(locale){
      if(!localeList.includes(locale)){
        return this.locale;
      }
      this.locale = locale;
      localStorage.setItem('grm_locale', locale);
      return this.locale;
    },
    toggleLocale: function(locales){
      locales = locales || localeList.concat();
      let idx = locales.findIndex(lc => lc===this.locale);
      idx += 1;
      if(idx >= locales.length){
        idx = 0;
      }
      let locale = locales[idx];
      return this.setLocale(locale);
    }
  });
  // localStorage.setItem("grm_locale", getLocale());
  dayjs.locale(getLocale());
};
